export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Início',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Registro',
  'menu.register-result': 'Resultado de registro',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Análise',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Ambiente de Trabalho',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Formulário',
  'menu.form.basic-form': 'Formulário Básico',
  'menu.form.step-form': 'Formulário Assistido',
  'menu.form.step-form.info':
    'Formulário Assistido(gravar informações de transferência)',
  'menu.form.step-form.confirm':
    'Formulário Assistido(confirmar informações de transferência)',
  'menu.form.step-form.result': 'Formulário Assistido(finalizado)',
  'menu.form.advanced-form': 'Formulário Avançado',
  'menu.list': 'Lista',
  'menu.list.table-list': 'Tabela de Busca',
  'menu.list.basic-list': 'Lista Básica',
  'menu.list.card-list': 'Lista de Card',
  'menu.list.search-list': 'Lista de Busca',
  'menu.list.search-list.articles': 'Lista de Busca(artigos)',
  'menu.list.search-list.projects': 'Lista de Busca(projetos)',
  'menu.list.search-list.applications': 'Lista de Busca(aplicações)',
  'menu.profile': 'Perfil',
  'menu.profile.basic': 'Perfil Básico',
  'menu.profile.advanced': 'Perfil Avançado',
  'menu.result': 'Resultado',
  'menu.result.success': 'Sucesso',
  'menu.result.fail': 'Falha',
  'menu.exception': 'Exceção',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Disparar',
  'menu.account': 'Conta',
  'menu.account.center': 'Central da Conta',
  'menu.account.settings': 'Configurar Conta',
  'menu.account.trigger': 'Disparar Erro',
  'menu.account.logout': 'Sair',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',

  // 建銀智能評估系統菜單
  'menu.operations': 'Operations Overview',
  'menu.customer': 'Customer Management',
  'menu.customer.customerAdd': 'Add Customer',
  'menu.customer.customerEdit': 'Edit Customer',
  'menu.task': 'Task Management',
  'menu.report': 'Report Management',
  'menu.activity': 'Activity Management',
  'menu.finance': 'Finance Management',
  'menu.platform': 'Platform Maintenance',
  'menu.netValueSolution': 'Net Value Solution',
  'menu.ledger': 'Ledger Management',
  'menu.system': 'System Management',

  // 系統管理子菜單
  'menu.organization': 'Organization Management',
  'menu.logs': 'Operation Logs',
  'menu.user': 'User Management',
  'menu.personal': 'Personal Settings',
  'menu.role': 'Role Management',
  'menu.settings': 'System Settings',

  // 完整的系統管理子菜單路徑
  'menu.system.organization': 'Organization Management',
  'menu.system.logs': 'Operation Logs',
  'menu.system.user': 'User Management',
  'menu.system.userCreate': 'Add User',
  'menu.system.userEdit': 'Edit User',
  'menu.system.personal': 'Personal Settings',
  'menu.system.role': 'Role Management',
  'menu.system.roleCreate': 'Add Role',
  'menu.system.permission': 'Permission Management',
  'menu.system.menu': 'Menu Configuration',
  'menu.system.settings': 'System Settings',

  // 完整的任務管理子菜單路徑
  'menu.task.taskMyTask': 'My Tasks',
  'menu.task.taskStatistics': 'Task Statistics',
  'menu.task.taskSupplement': 'Task Supplement',
  'menu.task.taskCreate': 'Create Task',
  'menu.task.reportReview': 'My Review',
  'menu.task.reportDetail': 'Report Details',

  // 完整的報告管理子菜單路徑
  'menu.report.reportStatistics': 'Report Statistics',
  'menu.report.reportDetail': 'Report Details',

  // Net value solution submenu
  'menu.netValueSolution.netValueSolutionAdd': 'Add Net Value Solution',
  'menu.netValueSolution.netValueSolutionList': 'Net Value Solution List',
  'menu.netValueSolution.netValueSolutionCommonParams': 'Common Parameters',
  'menu.netValueSolution.netValueSolutionPlanCustomParams':
    'Parâmetros personalizados do plano',
  'menu.netValueSolutionAdd': 'Add Net Value Solution',
  'menu.netValueSolutionList': 'Net Value Solution List',
  'menu.netValueSolutionCommonParams': 'Common Parameters',
  'menu.netValueSolutionPlanCustomParams': 'Parâmetros personalizados do plano',

  // Ledger submenu
  'menu.ledger.ledgerList': 'Ledger List',
  'menu.ledgerList': 'Ledger List',
  'menu.ledger.ledgerInquiry': 'Inquiry Ledger',
  'menu.ledgerInquiry': 'Inquiry Ledger',
  'menu.ledger.ledgerEdit': 'Edit Ledger',
  'menu.ledgerEdit': 'Edit Ledger',
};
